import {
  ENTIDADES_ENQUADRAMENTOS,
  ENTIDADES_ENQUADRAMENTOS_ADD,
  ENTIDADES_ENQUADRAMENTOS_MODIFY,
  ENTIDADES_ENQUADRAMENTOS_REMOVE,
  ENTIDADES_ENQUADRAMENTOS_COPY,
  ENTIDADES_ENQUADRAMENTOS_PADRAO,
} from "../const/servicesURI";

import { httpRequests } from "investira.sdk";
import requestService from "./requestService";
import utils from "../utils";

export const cancel = {
  list: null,
};

export const list = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pProps,
    cancelToken: cancel.list.token,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Entidades Enquadramentos List");
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    method: "POST",
    ...pProps,
    cancelToken: cancel.list.token,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_ADD, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Entidades Enquadramentos Add");
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const copy = (pProps, pResolve, pReject, pFinally) => {
  const xProps = {
    method: "POST",
    ...pProps,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_COPY, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Entidades Enquadramentos Copy");
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const modify = (pProps, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    method: "PATCH",
    ...pProps,
    cancelToken: cancel.list.token,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_MODIFY, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(
        rErr,
        "Error Service Entidades Enquadramentos Modify"
      );
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pId, pResolve, pReject, pFinally) => {
  const xProps = {
    method: "DELETE",
  };

  return requestService(xProps, `${ENTIDADES_ENQUADRAMENTOS_REMOVE}${pId}`, 3)
    .then((rRes) => {
      pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Entidade Delete");
      pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const padrao = (pProps, pResolve, pReject, pFinally) => {
  const xProps = {
    method: "POST",
    ...pProps,
  };

  return requestService(xProps, ENTIDADES_ENQUADRAMENTOS_PADRAO, 3)
    .then((rRes) => {
      return pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Entidades Enquadramentos Copy");
      return pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const entidadesEnquadramento = {
  list,
  remove,
  add,
  modify,
  copy,
  padrao,
  cancel,
};

export default entidadesEnquadramento;
